import { Component, OnInit, Inject, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { from } from 'rxjs';
import {
  DocumentoTipoRequisito,
  EstadoDocumentoItem,
  eTypeResult,
  ParametrosMaestro,
  SolicitudSeccion,
} from 'src/app/models/common/enumModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import {
  PersonalDialogModel,
  PersonalModel,
} from 'src/app/models/solicitud/PersonalModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { ISolicitudPersonaValidarEmpresaModel } from 'src/app/models/commands/solicitudes/solicitud-persona/interfaces/ISolicitudPersonaValidarEmpresaModel';
import { SolicitudPersonaValidarEmpresaModel } from 'src/app/models/commands/solicitudes/solicitud-persona/SolicitudPersonaValidarEmpresaModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-registrar-personal-dialog',
  templateUrl: './registrar-personal-dialog.component.html',
  styleUrls: ['./registrar-personal-dialog.component.css'],
})
export class RegistrarPersonalDialogComponent implements OnInit {
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'estado',
    'acciones',
  ];

  tipoSeccion: SolicitudSeccion = SolicitudSeccion.Personal;
  codigoSolicitud: string;
  idSolicitud: number;
  emailPattern: string = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  listaTipoDocumentoIdentidad!: ParametroModel[];
  logs: ILogModel[] = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<RegistrarPersonalDialogComponent>,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
    private parametroService: ParametroService,
    private alertDialogService: AlertDialogService,
    private confirmDialogService: ConfirmDialogService,
    @Inject(MAT_DIALOG_DATA) public data: PersonalDialogModel
  ) {
    this.idSolicitud = data.persona.idSolicitud;
    this.codigoSolicitud = data.persona.codigoSolicitud;
  }

  ngOnInit(): void {
    if (this.data.persona.enableEdit) {
      this.displayedColumns = this.displayedColumns.filter(
        (p) => p !== 'estado'
      );
    }

    if (this.data.persona.idSolicitudPersona != 0) {
      this.solicitudPersonaService.getById(this.data.persona.idSolicitud, this.data.persona.idSolicitudPersona).subscribe((result) => {
        console.log(result);
        this.logs = result.logs.filter(p => p.comentarios != "" && p.comentarios != null);
      });
    }

    this.data.persona.comentarios = "";

    this.parametroService
      .getDetalles(ParametrosMaestro.TiposDocumentosIdentidad)
      .subscribe((p) => {
        this.listaTipoDocumentoIdentidad = p.items;
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined =
      this.data.persona.documentos.find(
        (p) =>
          p.idSolicitudDocumentoRequerido ===
          newItem.idSolicitudDocumentoRequerido
      );
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.rutaArchivo = newItem.rutaArchivo;
      element.contieneDocumento = true;
    }
  }

  removeItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined =
      this.data.persona.documentos.find(
        (p) =>
          p.idSolicitudDocumentoRequerido ===
          newItem.idSolicitudDocumentoRequerido
      );
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.contieneDocumento = false;
    }
  }

  onSubmit(form: NgForm) {

    if (!form.invalid) {
      let documentosObligatorios = this.data.persona.documentos.filter(
        (p) =>
        (
          p.idRequisito == DocumentoTipoRequisito.TODOS &&
          (
            p.contieneDocumento == false ||
            (p.controlarFechas === true && !p.fechaVencimiento)
          )
        )
      );

      if (documentosObligatorios.length > 0) {
        this.alertDialogService.open('Debe ingresar los documentos o fechas de vencimiento obligatorios');
      } else {
        if (this.data.persona.idTipoDocumentoIdentidadSelected) {
          this.data.persona.idTipoDocumentoIdentidad = this.data.persona.idTipoDocumentoIdentidadSelected;
          if (this.data.persona.idSolicitudPersona == 0) {
            let commandValidar: ISolicitudPersonaValidarEmpresaModel = new SolicitudPersonaValidarEmpresaModel();
            commandValidar.idTipoDocumentoIdentidad = this.data.persona.idTipoDocumentoIdentidadSelected;
            commandValidar.nroDocumentoIdentidad = this.data.persona.nroDocumentoIdentidad;
            commandValidar.idContratista = this.data.persona.idContratista;
            commandValidar.idSede = this.data.persona.idSede;
            this.solicitudPersonaService.validarempresa(commandValidar).subscribe((result: ActionResultModel) => {
              if (result.type == eTypeResult.WARNING) {
                this.confirmDialogService.open(result.message); //options
                this.confirmDialogService.confirmed().subscribe((confirmResult) => {
                  if (confirmResult) {
                    this.data.persona.notificarCambio = true;
                    this.solicitudPersonaService.guardar(this.data.persona).subscribe((result: ActionResultModel) => {
                      if (result.type != eTypeResult.SUCCESS) {
                        this.alertDialogService.open(result.message);
                      } else {
                        this.dialogRef.close();
                      }
                    });
                  }
                });
              } else if (result.type == eTypeResult.ERROR) {
                this.alertDialogService.open(result.message);
              } else {
                this.solicitudPersonaService.guardar(this.data.persona).subscribe((result: ActionResultModel) => {
                  if (result.type != eTypeResult.SUCCESS) {
                    this.alertDialogService.open(result.message);
                  } else {
                    this.dialogRef.close();
                  }
                });
              }
            });
          }
          else {
            this.solicitudPersonaService.guardar(this.data.persona).subscribe((result: ActionResultModel) => {
              if (result.type != eTypeResult.SUCCESS) {
                this.alertDialogService.open(result.message);
              } else {
                this.dialogRef.close();
              }
            });
          }
        }
      }
    }
  }

  // createImageFromBlob(image: Blob) {
  //   let reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //      this.imageToShow = reader.result;
  //   }, false);

  //   if (image) {
  //      reader.readAsDataURL(image);
  //   }
  //  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor:VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion=SolicitudSeccion.Personal;
      modelVisor.idRegistro = this.data.persona.idSolicitudPersona;
      modelVisor.idSolicitudDocumento = element.idSolicitudPersonaDocumento;
      modelVisor.codigoSolicitud = this.data.persona.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudPersonaDocumentoService.downloadDocumento(
        this.data.persona.codigoSolicitud,
        this.data.persona.idSolicitudPersona,
        element.idSolicitudPersonaDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      },);
    }
  }

  keyPressAlfanumericoOnly(event: any) {
    const pattern = /^[A-Za-z0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}